function updateSelect2zIndex(modal) {
	modal.querySelectorAll('.select2-container').forEach((it) => { it.style.zIndex = modal.style.zIndex });
}

document.addEventListener('turbo:before-render', () => {
	try {
		document.querySelectorAll('.select2-hidden-accessible').forEach(($el) => {
			!!$($el).data('select2') && $($el).select2('destroy');
		});
	} catch (ex) {
		console.log(ex);
	}
});

document.addEventListener("turbo:load", () => {
	$(document).on('hide.bs.modal','.modal', (ev) => updateSelect2zIndex(ev.currentTarget));
	$(document).on('show.bs.modal','.modal', (ev) => updateSelect2zIndex(ev.currentTarget));
});